import React from "react";

export const DASHBOARD_HELP_TITLE = "Painel";

export function DashboardHelpContent() {
  return (
    <>
      <p>
        <strong>Para que serve?</strong> Esta é a página inicial da fazenda — a
        visão central de tudo que acontece no campo e no escritório. Aqui você
        acompanha máquinas, operações, deslocamentos e comunicação com a equipe
        em um só lugar.
      </p>
      <p>
        <strong>Indicadores no topo:</strong>
      </p>
      <ul>
        <li>
          <strong>Telemetria encerrada</strong> — operadores que estavam ativos
          e saíram. Mostra a data, a hora e há quanto tempo. Clique no nome
          para abrir a última localização no rastreamento.
        </li>
        <li>
          <strong>Alertas</strong> — clique para marcar quais avisos abrem no
          meio da tela (telemetria, assumir/finalizar máquina, pausa e rádio).
          Dá para avisar também por cima de outro site ou programa, enquanto
          esta página estiver aberta no navegador.
        </li>
        <li>
          <strong>Telemetria ativa</strong> — ao clicar, o quadro fica verde
          e o mapa mostra o rastro de quem está com telemetria ligada na
          última 1 h, 12 h ou 24 h. No nome, a data, a hora e há quanto tempo
          entrou. O ícone dos demais continua na última posição.
        </li>
        <li>
          <strong>Rastros na tela</strong> — ao clicar, o quadro fica verde.
          À esquerda ficam os operadores e à direita as máquinas. Dá para
          marcar um, o outro ou os dois. Clique no quadro para abrir mais
          uns dez nomes por cima do mapa; clique de novo nele ou ao lado
          para recolher. O i ao lado do título avisa que marcar muita gente
          ou um período longo deixa o mapa mais lento. Em
          cima, 1 h, 12 h e os últimos sete dias. Cada dia liga e desliga
          com um clique e abre o rastro de quem está marcado. O dia de hoje
          fica logo depois das 12 h. O calendário escolhe outro período. O ícone de quem não foi marcado
          continua no mapa. O grupo no canto escolhe quem do cadastro entra
          nessa lista. Período longo e
          muitas pessoas deixam a abertura mais lenta. Se o operador já
          assumiu a máquina, os dois marcados viram um rastro só. O clique
          mostra o operador e a máquina. Sem máquina assumida, o clique
          mostra só o operador. Desmarcar a máquina deixa o rastro dele.
          O toque na linha pega
          uma faixa maior em volta do traço. Se duas linhas estiverem perto,
          abre a que está mais no meio do clique. Clique no rastro para
          ver o nome e, quando houver operação ou ordem de serviço naquela
          data e máquina, a anotação do trabalho.
        </li>
        <li>
          <strong>Ociosidade</strong> — percentual e tempo ocioso no período
          selecionado.
        </li>
      </ul>
      <p>
        <strong>Mapa — máquinas e deslocamento:</strong>
      </p>
      <ul>
        <li>
          Só entram no mapa as máquinas que já tiveram o{" "}
          <strong>primeiro movimento</strong>. O ícone fica na última
          localização conhecida. Reserva e máquina ainda parada não aparecem.
        </li>
        <li>
          A máquina usa o ícone escolhido no cadastro. Quem ativou a telemetria
          aparece como <strong>operador</strong>, sempre junto da máquina
          (embaixo). Esse ícone de telemetria não se escolhe — é fixo.
        </li>
        <li>
          Você vê o <strong>deslocamento em tempo real</strong> enquanto a
          página está aberta — ícones se movem conforme a máquina trabalha.
        </li>
        <li>
          Cores do mapa: <strong>verde</strong> só se o GPS dos últimos 2
          minutos e meio mostrar movimento, ou nos primeiros 2 minutos e meio
          depois de assumir no app; velocidade antiga não conta;{" "}
          <strong>amarelo</strong> se a máquina ou o pedestre ficou parado no
          mesmo lugar por mais de 2 minutos e meio com alguém assumido;{" "}
          <strong>laranja</strong> se a máquina
          está parada e ninguém assumiu no aplicativo. Ao{" "}
          <strong>desativar a telemetria</strong>, pessoa e máquina ficam
          verdes por 10 segundos, amarelas por mais 10 segundos e depois
          laranja até a telemetria ser ligada de novo. Pausa por intervalo
          fica <strong>azul</strong> 10 segundos depois que o evento sobe.
          Esses horários vêm do servidor, então continuam depois de
          atualizar a página.
        </li>
        <li>
          Use o botão do <strong>trator</strong> no canto do mapa para abrir a
          lista de máquinas e ir ao detalhe de cada uma.
        </li>
      </ul>
      <p>
        <strong>Rastros (24 horas, ou 7 dias na cerca):</strong>
      </p>
      <ol>
        <li>
          O mapa abre sempre na <strong>última 1 hora</strong>. Depois você
          escolhe <strong>12 h</strong> ou <strong>24 h</strong>. Com um ou
          mais talhões selecionados, o prazo vai até <strong>7 dias</strong>,
          só dentro dessas cercas.
        </li>
        <li>
          Clique em <strong>Rastros</strong> para escolher{" "}
          <strong>Última 1 h</strong>, <strong>Últimas 12 h</strong>,{" "}
          <strong>Últimas 24 h</strong> ou, com talhão marcado,{" "}
          <strong>Últimos 7 dias</strong>. Clique de novo no talhão para
          desmarcar.
        </li>
        <li>
          O rastro de todas as máquinas e operadores do período aparece no
          mapa. Os ícones continuam no último ponto conhecido.
        </li>
        <li>
          Em <strong>Cores</strong>, escolha a cor de cada máquina ou a
          velocidade. A velocidade planejada vale para todas: amarelo mais de
          10% abaixo, azul dentro da velocidade planejada e vermelho mais de
          10% acima.
        </li>
      </ol>
      <p>
        <strong>Rádio — comunicação com a equipe no campo:</strong>
      </p>
      <ul>
        <li>
          O ícone de <strong>rádio</strong> no mapa abre a comunicação por áudio,
          como um HT: segure para falar e solte para enviar.
        </li>
        <li>
          Os áudios enviados pela equipe no app aparecem na janela — você ouve e
          responde direto pelo navegador.
        </li>
        <li>
          O <strong>histórico da conversa</strong> fica visível no painel: quem
          falou, quando e em qual grupo.
        </li>
        <li>
          Para gestão completa dos grupos, use o menu <strong>Rádio</strong> na
          barra lateral.
        </li>
      </ul>
      <p>
        <strong>Rádio via internet — sem limite de distância:</strong>
      </p>
      <ul>
        <li>
          Diferente de um HT comum, o rádio da plataforma funciona pela{" "}
          <strong>internet</strong> — não há limite de alcance entre escritório,
          fazenda e operadores, desde que app e plataforma tenham conexão.
        </li>
        <li>
          Se o operador estiver <strong>sem sinal ou fora da área</strong> no
          momento do envio, a mensagem <strong>não se perde</strong>: fica salva
          e chega assim que o app voltar a ter internet.
        </li>
        <li>
          Todas as mensagens ficam <strong>registradas no histórico</strong> —
          você pode ouvir quantas vezes quiser, na plataforma ou no app.
        </li>
      </ul>
      <p>
        <strong>Resumo:</strong> abra o Painel no início do dia para ver onde
        estão as máquinas, o que está rodando, recuperar rastros das últimas
        horas e falar com o campo sem sair da tela.
      </p>
    </>
  );
}
